import React, { useEffect, useMemo, useState } from 'react'
import UserProfile from '../../components/UserProfile'
import { Link, useNavigate } from 'react-router-dom'
import axios from 'axios'
import BasicTable from '../../components/BasicTable'
import { ValidateAPI, formatDate } from '../../utils/Utils'
import { AdminTabledateFormat } from './HFTUser'
import axiosInstance from '../../api/axiosInstance'
const Roles = () => {
  const navigate = useNavigate()
  const [supplierContactList, setContactList] = useState([])
  const column = useMemo(() => [
    { header: 'ROLE ID', accessorKey: 'ID_ROLE' },
    { 
      header: 'ROLE NAME',
       accessorKey: 'ROLE_NAME',
       filterFn: (row, id, value) => {
        return value.includes(row.getValue(id))
      }
     },
    // {
    //   header: 'ACTION NEEDED',
    //   accessorKey: 'ACTION_NEEDED',
    // },
    // { header: 'DC', accessorKey: 'DC' },
    // {
    //   header: 'ORIGINAL_SHIP_WEEK',
    //   accessorKey: 'ORIGINAL_SHIP_WEEK'
    // },
    // {
    //   header: 'CURRENT_SHIP_WEEK',
    //   accessorKey: 'CURRENT_SHIP_WEEK'
    // },
    // {
    //   header: 'ORIGINAL_QTY',
    //   accessorKey: 'ORIGINAL_QTY'
    // },
    // {
    //   header: 'CURRENT_QTY',
    //   accessorKey: 'CURRENT_QTY'
    // },
    // {
    //   header: 'VENDOR_UPDATE_RESPONSE',
    //   accessorKey: 'VENDOR_UPDATE_RESPONSE'
    // },

    // {
    //   header: 'STATUS',
    //   accessorKey: 'ENABLED',
    //   cell: (info) => (info?.getValue() === 'Y' ? 'ENABLED' : 'DISABLED')
    // },
    // {
    //   header: 'CREATED AT',
    //   accessorKey: 'CREATEDAT',
    //   cell: (info) =>
    //     info?.getValue() !== null ? AdminTabledateFormat(info?.getValue()) : ''
    // },
    // {
    //   header: 'UPDATED AT',
    //   accessorKey: 'UPDATEDAT',
    //   cell: (info) =>
    //     info?.getValue() !== null ? AdminTabledateFormat(info?.getValue()) : ''
    // }
  ])
  const getAllVendorContact = () => {
    axiosInstance
      .get(`/api/admin/get-all-enabled-role-permissions`)
      .then((res) => {
        setContactList(res?.data)
      })
      .catch((error) => {
        if (error.response.status === 401 || error.response.status === 403) {
          navigate('/login-error')
        }
      })
  }
  useEffect(() => {
    getAllVendorContact()
  }, [])

  return (
    <div className='p-2 w-full  flex flex-col  gap-5'>
      <div className='w-full justify-between flex items-center'>
        <div className=''>
          <p className='text-xl font-medium'>Roles</p>
        </div>
        {/* <UserProfile /> */}
      </div>
      {/* BreadCrumb */}
      <div className='w-full text-xs flex justify-start items-center gap-1 font-medium text-gray-600'>
        <p className='flex gap-1 items-center justify-center'>
          <span
            className='hover:underline cursor-pointer'
            onClick={() => navigate('/admin')}
          >
            Home
          </span>
          <span>{'>'}</span>
        </p>

        <p className='flex gap-1 items-center justify-center'>
          <span>Roles </span>
        </p>
      </div>
      
      {/* ALL Contac List*/}
      {supplierContactList?.length !== 0 && (
        <BasicTable tableData={supplierContactList} columns={column} />
      )}
    </div>
  )
}

export default Roles
